import UrlHelper from 'foundation/url-helper';

export const ecommerceEventTypes = Object.freeze({
    ADD_TO_CART: 'add_to_cart',
    REMOVE_FROM_CART: 'remove_from_cart',
    SELECT_ITEM: 'select_item',
    VIEW_ITEM_LIST: 'view_item_list',
    BEGIN_CHECKOUT: 'begin_checkout'
});

class GTM {
    _send(event, data) {
        if (window.dataLayer) {
            window.dataLayer.push({ event, ...data });
        }
    }

    push(category, action, label) {
        this._send('eventTrack', {
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            user_id: (window.localStorage.userId === null || window.localStorage.userId === undefined) ? '' : window.localStorage.userId
        });
    }

    pushEcommerceEvent(eventType, ecommerceObject) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: eventType,
            ecommerce: ecommerceObject
        });
    }

    sendVirtualUrl(url, title) {
        this._send('pageviewTrack', { pageUrl: url, pageTitle: title });
    }

    sendCurrentLocationAsVirtualUrl(title) {
        this.sendVirtualUrl(UrlHelper.getRelativeUrl(window.location), title);
    }
}

export default new GTM();
